var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWing1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 55,
    viewBox: "0 0 54 55",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M50.4263 45.3413C46.74 43.29 44.5838 39.7875 44.3663 36.5794C43.2056 19.3969 14.5744 17.16 0 0C0.755625 21.8644 24.7575 21.7575 38.895 32.7169C29.7469 28.755 14.7525 29.625 3.9 22.5844C8.9625 39.0375 27.0225 33.6206 40.2863 38.0925C32.3888 37.3219 21.9713 41.7825 12.1238 38.2537C20.82 51.96 32.1 42.8044 43.0294 42.885C37.5169 44.2894 31.8225 50.4319 24.2119 49.8563C33.4856 58.7812 38.3419 50.1169 44.985 46.7944C44.3156 47.5913 43.8919 48.6075 43.8413 49.7288C43.7212 52.4344 45.8175 54.7256 48.5231 54.8475C51.2287 54.9694 53.52 52.8713 53.6419 50.1656C53.7394 47.9738 52.3819 46.0537 50.4244 45.3394L50.4263 45.3413Z",
    fill: "#9393B0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWing1);
export default __webpack_public_path__ + "static/media/wing1.ddf187123482193c1a0578016746a7cc.svg";
export { ForwardRef as ReactComponent };